import { api } from "@repo/convex/api";
import { useQuery } from "convex/react";
import { ShieldAlert } from "lucide-react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Skeleton } from "@/components/ui/skeleton";
import { useRightSidebarEntity, useRightSidebarProject } from "../../contexts";
import { QgNextEntityPanel } from "../quality-guard/qg-next-entity-panel";
import { QualityGuardEntityPanel } from "../quality-guard/quality-guard-entity-state";

export function GuardianPanel() {
  const { projectId } = useRightSidebarProject();
  const { entityType, entityId, entityName, entityTabKey, entityFieldId } = useRightSidebarEntity();
  const next = useQuery(
    api.qgNext.read.getEntityPanel,
    entityType && entityId ? { projectId, entityId } : "skip"
  );

  if (!entityType || !entityId) {
    return (
      <ScrollArea className="flex-1 px-4">
        <div className="py-4">
          <div className="rounded-md border border-dashed p-4 text-center text-muted-foreground">
            <ShieldAlert className="mx-auto mb-2 size-7" />
            <p className="text-sm font-medium">No entity selected</p>
            <p className="mt-1 text-xs">Open an entity to see Quality Guard findings.</p>
          </div>
        </div>
      </ScrollArea>
    );
  }

  if (next === undefined) {
    return (
      <div className="space-y-3 px-4 py-4">
        <Skeleton className="h-4 w-28" />
        <Skeleton className="h-20 w-full" />
      </div>
    );
  }

  if (next.ofRecord) {
    return (
      <QgNextEntityPanel
        projectId={projectId}
        entityTypeKey={entityType}
        entityId={entityId}
        entityName={entityName}
        sectionTabKey={entityFieldId ? entityTabKey : null}
        sectionFieldId={entityFieldId}
        panel={next}
      />
    );
  }

  return (
    <QualityGuardEntityPanel
      projectId={projectId}
      entityTypeKey={entityType}
      entityId={entityId}
      entityName={entityName}
      sectionTabKey={entityFieldId ? entityTabKey : null}
      sectionFieldId={entityFieldId}
    />
  );
}
